import React, { useContext } from 'react'
import axios from 'axios';

/// React router dom
import { Routes, Route, Outlet } from 'react-router-dom'
import { useSelector } from "react-redux";
/// Css
import './index.css'
import './chart.css'
import './step.css'

/// Layout
import Nav from './layouts/nav'
import Footer from './layouts/Footer'
import { ThemeContext } from "../context/ThemeContext";


/// App
import AppProfile from './components/AppsMenu/AppProfile/AppProfile'
import Updateprofile from './components/AppsMenu/AppProfile/Updateprofile';
import Calendar from './components/AppsMenu/Calendar/Calendar'
import CalendarData from './components/AppsMenu/Calendar/calendarData'



//Scroll To Top
import ScrollToTop from './layouts/ScrollToTop';

//user detail
import Demography from './pages/userdetail/Demography';
import EmailID from './pages/userdetail/emailID';
import UserName from '../jsx/pages/userdetail/username';
import DOB from './pages/userdetail/dobPage';
import GenderPage from './pages/userdetail/gender';
import HeightPage from './pages/userdetail/HeightPage';
import WeightPage from './pages/userdetail/WeightPage';
import BloodGroupPage from './pages/userdetail/BloodGroupPage';
import FullDetailPage from './pages/userdetail/FullDetailPage';
import ProfessionalPage from './pages/userdetail/ProfessionalPage';
import MaritalStatusPage from './pages/userdetail/maritial';


/// Dashboard
import Home from "./components/Dashboard/Home";
import WorkoutStatistic from "./components/Dashboard/WorkoutStatistic";
import WorkoutPlan from "./components/Dashboard/WorkoutPlan";
import PersonalRecord from "./components/Dashboard/PersonalRecord";
import BloodPressureReport from "./components/Dashboard/BloodPressureReport";
import BloodSugarReport from "./components/Dashboard/bloodSugarReport";
import MoodAnalytics from "./components/Dashboard/MoodAnalytics";

//Document Upload
import DoctorPrescription from './components/DocumentUpload/DoctorPrescription/index'

// First Aid
import FirstAid from './components/FirstAid/FirstAid';
import AddFirstAid from './components/FirstAid/AddFirstAid';
import EditFirstAid from './components/FirstAid/EditFirstAid';

// Vaccination
import Vaccination from './components/Vaccination/vaccination'
import AddVaccination from './components/Vaccination/AddVaccination'
import EditVaccination from './components/Vaccination/EditVaccination'


// Mood Monitor
import MoodMonitor from './components/MoodMonitor/mood'
import AddMood from './components/MoodMonitor/addmood';

import PeriodTracker from './components/periodTracker/index'

// blood presssure and blood dugre
import Diabetes from './components/Diabetes/index'
import BloodPressure from './components/Bloodpressure/index'

//MEDICALcHECKUPLIST

import Medicalcheckup from './components/Medicalcheckup/medicalcheckuplist';
import AddMedicalcheckup from './components/Medicalcheckup/AddMedicalcheckup';
import EditMedicalcheckup from './components/Medicalcheckup/EditMedicalcheckup';

//FOOD DETSILS
import Fruits from './components/FruitsDetails/Fruits';
import AddFruitdetais from './components/FruitsDetails/addFruits';
import EditFruitdetais from './components/FruitsDetails/updateFruits';

import Vegetables from './components/VegetableDetails/Vegetable'
import AddVegetablelist from './components/VegetableDetails/addVegetable'
import UpdateVegetables from './components/VegetableDetails/updateVegetable'

import Grains from './components/GrainsDetails/Grains';
import AddgrainDetails from './components/GrainsDetails/addGrains';
import UpdategrainDetails from './components/GrainsDetails/updateGrains';

import Symptoms from './components/Symptoms/Symptoms';
import AddSymptoms from './components/Symptoms/AddSymptoms';
import UpdateSymptoms from './components/Symptoms/EditSymptoms';

import Slides from './pages/Slideshow';

//Chnage password
import Changepassword from './layouts/nav/Changepassword';
// import UiCarousel from './components/FoodDetails/Carousel'
//BLOOD SCREEN
import Blood from './components/Bloodgroup/Blood';
import FindDonner from './components/Bloodgroup/findDonor';
import RequestDonner from './components/Bloodgroup/requestDonner';
import AcceptedList from './components/Bloodgroup/acceptedList';
import CreatePost from './components/Bloodgroup/CreatePost';
import BloodNotification from './components/Bloodgroup/bloodNotification';
import TrackHistory from './components/Bloodgroup/trackHistory';

import Blooddetails from './components/Bloodgroup/Bloodetails';
import BMICalculator from './components/BMICalculator/index';

import Depression from './components/MoodMonitor/depression';
// import DAS from './components/MoodMonitor/dasquestion';
import Anxiety from './components/MoodMonitor/anxiety';
import Stress from './components/MoodMonitor/stress';
import DASHOME from './components/MoodMonitor/mentalhealth';
import AppUpdate from './components/AppUpdate/Appupdate';
import Questions from './components/Questions/app.js';

//Notification
import Notification from './components/Notification/Notification';
import ScheduledNotification from './components/Notification/ScheduledNotification';

// Auditlog
import Auditlog from './components/Auditlog/Auditlog';
import ScreenAuditlog from './components/ScreenAuditlog/ScreenAuditlog';
import DemographicScreen from './components/ScreenAuditlog/DemographicScreen';
import ScreenInsights from './components/ScreenAuditlog/ScreenInsights';

// Configure
import AllUsers from './components/Configure/AllUsers';

// Loader
import Loader from './components/common/Loader';

// Articles
import MobPushArticles from './components/Mobile-end/MobPeriod-Push';
import OverAllPeriodTracking from './components/Mobile-end/overAllPeriodTracking/Overall_PeriodTrackingArticle';
import AIInsights from './components/AI-Insights/index.jsx';

// Support Ticket
import PersonalChat from "../jsx/components/Support-tickets/PersonalChat.tsx"
import SupportTickets from "../jsx/components/Support-tickets/Support_tickets.tsx"
// Profile Questions
import ProfileQuestions from './components/ProfileQuestions/ProfileQuestions';
import AddProfileQuestion from './components/ProfileQuestions/AddProfileQuestion';
import EditProfileQuestion from './components/ProfileQuestions/EditProfileQuestion';
import AddMusic from './components/MusicManagement.tsx/AddMusic.js';
import EditMusic from './components/MusicManagement.tsx/EditMusic.js';
import MusicManagelisting from './components/MusicManagement.tsx/MusicMainPage.js';

// Period Tracking Dashboard
import PeriodTrackingDashboard from './components/PeriodTrackingDashboard';
import PeriodProfiles from './components/PeriodTrackingDashboard/PeriodProfiles';

// Vitals
import Vitals from './components/Vitals/Vitals';

// Pregnancy Tracking
import PregnancyTracking from './components/PregnancyTracking/PregnancyTracking';

// config
import Configure from './components/Configure/Configure';

// system config
import SystemConfig from './components/System Config/SystemConfig';

// Admin Creation
import AdminCreation from './components/AdminCreation/AdminCreation';
import AddAdmin from './components/AdminCreation/AddAdmin';
import AppMenu from './components/AdminRoleMenus/AppMenu';
import RoleManagement from './components/RoleManagement/RoleManagement';

// API Analytics
import APIAnalytics from './components/APIAnalytics/apiAnalytics';
import UserAPIAnalytics from './components/APIAnalytics/UserAPIAnalytics';
import MicroserviceFeature from './components/MicroserviceFeatures/FeatureIndex.js';

 const Markup = () => {
 const allroutes = React.useMemo(() => [
    //user detail
    { url: 'EmailID', component: <EmailID /> },
    { url: 'NamePage', component: <UserName /> },
    { url: 'DOB', component: <DOB /> },
    { url: 'GenderPage', component: <GenderPage /> },
    { url: 'HeightPage', component: <HeightPage /> },
    { url: 'WeightPage', component: <WeightPage /> },
    { url: 'BloodGroupPage', component: <BloodGroupPage /> },
    { url: 'FullDetailPage', component: <FullDetailPage /> },
    { url: 'ProfessionalPage', component: <ProfessionalPage /> },
    { url: 'MaritalStatusPage', component: <MaritalStatusPage /> },
    { url: 'Demography', component: <Demography /> },


    // configure 
    { url: 'Users', component: <AllUsers /> },

    // Period Tracker
    { url: 'period-tracking-dashboard', component: <PeriodTrackingDashboard /> },
    { url: 'period-profiles', component: <PeriodProfiles /> },
    { url: 'MobPushArticles', component: <MobPushArticles /> },
    { url: 'OverAllPeriodTracking', component: <OverAllPeriodTracking /> },

    /// Dashboard
    { url: '', component: <Home /> },
    { url: 'dashboard', component: <Home /> },

    { url: "workout-statistic", component: <WorkoutStatistic /> },
    { url: "workoutplan", component: <WorkoutPlan /> },
    { url: "personal-record", component: <PersonalRecord /> },

    //notification
    { url: 'notification', component: <Notification /> },
    { url: 'scheduled-notification', component: <ScheduledNotification /> },
    { url: 'Questions', component: <Questions /> },

    // Auditlog
    { url: 'auditlog', component: <Auditlog /> },
    { url: 'screen-auditlog', component: <ScreenAuditlog /> },
    { url: 'DemographicScreen', component: <DemographicScreen /> },
    { url: 'screen-insights/:screenName', component: <ScreenInsights /> },
    { url: 'screen-insights', component: <ScreenInsights /> },

    /// Apps
    { url: 'app-profile', component: <AppProfile /> },
    { url: 'update-profile/:id', component: <Updateprofile /> },
    { url: 'app-calender', component: <Calendar /> },
    { url: 'calenderData', component: <CalendarData /> },

    //First-Aid
    { url: 'first-aid', component: <FirstAid /> },
    { url: 'first-aid/add', component: <AddFirstAid /> },
    { url: 'first-aid/edit/:id', component: <EditFirstAid /> },


    //Vaccination
    { url: 'vaccination', component: <Vaccination /> },
    { url: 'vaccination/add', component: <AddVaccination /> },
    { url: 'vaccination/edit/:id', component: <EditVaccination /> },

    //Mood Monitor
    { url: 'mood_monitor', component: <MoodMonitor /> },
    { url: 'add_mood', component: <AddMood /> },

    { url: 'Diabetes', component: <Diabetes /> },
    { url: 'BloodPressure', component: <BloodPressure /> },
    // PeriodTracker
    { url: 'PeriodTracker', component: <PeriodTracker /> },

    // BMICalculator
    { url: 'BMICalculator', component: <BMICalculator /> },
    { url: 'ai-insights', component: <AIInsights /> },

    //Document Upload
    { url: 'Doctor-Prescription', component: <DoctorPrescription /> },
    // { url: 'Lab-Reports', component: <LabReports /> },
    // { url: 'Medical-Report', component: <MedicalReport /> },

    //MEDICALCHECKUPLIST
    { url: "med_list", component: <Medicalcheckup /> },
    { url: "med_list/add", component: <AddMedicalcheckup /> },
    { url: "med_list/edit/:id", component: <EditMedicalcheckup /> },

    //FoodDetails
    { url: "fruits", component: <Fruits /> },
    { url: "fruits/add", component: <AddFruitdetais /> },
    { url: "fruits/edit/:id", component: <EditFruitdetais /> },

    { url: "vegetables", component: <Vegetables /> },
    { url: "vegetables/add", component: <AddVegetablelist /> },
    { url: "vegetables/edit/:id", component: <UpdateVegetables /> },

    { url: "grains", component: <Grains /> },
    { url: "grains/add", component: <AddgrainDetails /> },
    { url: "grains/edit/:id", component: <UpdategrainDetails /> },

    { url: "symptoms", component: <Symptoms /> },
    { url: "symptoms/add", component: <AddSymptoms /> },
    { url: "symptoms/edit/:id", component: <UpdateSymptoms /> },

    { url: 'slide-show', component: <Slides /> },

    // { url: 'ui-carousel', component: <UiCarousel/> },

    //change Password
    { url: "changepassword", component: <Changepassword /> },


    //Blood Screen
    { url: "blood", component: <Blood /> },
    { url: "finddonor", component: <FindDonner /> },
    { url: "requestDonner", component: <RequestDonner /> },
    { url: "acceptedList", component: <AcceptedList /> },
    { url: "createpost", component: <CreatePost /> },
    { url: "bloodNotification", component: <BloodNotification /> },
    { url: "trackHistory", component: <TrackHistory /> },

    { url: "requestDonner/:id", component: <RequestDonner /> },
    { url: "finddonor/:id", component: <FindDonner /> },
    { url: "blood-details/:id", component: <Blooddetails /> },
    // { url: 'das', component: <DAS /> },
    { url: 'depression', component: <Depression /> },
    { url: 'anxiety', component: <Anxiety /> },
    { url: 'stress', component: <Stress /> },
    { url: 'mentalhealth', component: <DASHOME /> },
    { url: 'app-update', component: <AppUpdate /> },

    // Dashboard
    { url: 'blood-pressure-report', component: <BloodPressureReport /> },
    { url: 'blood-sugar-report', component: <BloodSugarReport /> },
    { url: 'mood-analytics', component: <MoodAnalytics /> },

    // Suppot Tickets
    { url: 'support-tickets', component: <SupportTickets /> },
    { url: 'user-chat/:ticketId', component: <PersonalChat /> },

    // Profile Questions
    { url: 'profile-questions', component: <ProfileQuestions /> },
    { url: 'profile-questions/add', component: <AddProfileQuestion /> },
    { url: 'profile-questions/edit/:id', component: <EditProfileQuestion /> },
    // Profile Questions
    { url: 'music-listing', component: <MusicManagelisting /> },
    { url: 'add-music', component: <AddMusic /> },
    { url: 'edit-music/:id', component: <EditMusic /> },

    // Vitals
    { url: 'vitals', component: <Vitals /> },
  
    // Configure
    { url: 'configure', component: <Configure /> },

    // System Config
    { url: 'system-config', component: <SystemConfig /> },
    
    // Admin Creation
    { url: 'admin-creation', component: <AdminCreation /> },
    { url: 'admin-creation/add', component: <AddAdmin /> },
    { url: 'admin-creation/edit/:id', component: <AddAdmin /> },
    { url: 'app-menu', component: <AppMenu /> },
    { url: 'role-management', component: <RoleManagement /> },

    // Pregnancy Tracking
    { url: 'pregnancy-tracking', component: <PregnancyTracking /> },

    // API Analytics
    { url: 'api-analytics', component: <APIAnalytics /> },
    { url: 'user-api-auditlog', component: <UserAPIAnalytics /> },
    { url: 'microservice-feature', component: <MicroserviceFeature /> },

  ], [])

  return (
    <>
      <Routes>

        <Route element={<MainLayout />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`/${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  )
}

function MainLayout() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector(state => state.sideMenu);
  return (
    <>
      <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}>
        <Nav />
        <div className="content-body" style={{ minHeight: "calc(100vh - 60px)", background: "#F6F9FB" }}>
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>

    </>
  )
};

axios.interceptors.request.use(
  (config) => {
    // 1. Get user details from localStorage
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
    const userId = localStorage.getItem('id') || userDetails?._id;
    // 2. Attach it to the headers for backend analytics tracking
    if (userId) {
        config.headers = config.headers || {};
        config.headers['admin-id'] = userId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default Markup